import React, { useState } from 'react'
import { StyleSheet, Text } from 'react-native'
import Button from '../../../../components/Button'
import Input from '../../../../components/Input'
import Spinner from '../../../../components/Spinner'
import CompanyType from '../../../../models/company-type'
import { saveCompanyType } from '../../../../services/api'
import { isEmpty } from '../../../../shared/utils'

export interface CompanyTypeFormProps {
    originalCompanyType?: CompanyType
    onBack: () => void
}

const CompanyTypeForm = ({
    originalCompanyType,
    onBack,
}: CompanyTypeFormProps) => {
    const [name, setName] = useState(originalCompanyType?.name || '')
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)

    const _save = async () => {
        if (isEmpty(name)) {
            setErrorMessage('Por favor, informe o nome do tipo de empresa.')
        } else {
            setErrorMessage('')
            setLoading(true)
            try {
                const data = {
                    companyType: {
                        id: 0,
                        name: name.trim(),
                    },
                }
                if (originalCompanyType) {
                    data.companyType.id = originalCompanyType.id
                }

                const result = await saveCompanyType(data)
                if (originalCompanyType && result) {
                    // setEditing(false)
                    // const r = new Statement(result.statement)
                    // onStatementUpdated(r)
                } else {
                    onBack()
                }
            } catch (e) {
                console.log('CompanyTypeForm exception: ', e)
                setErrorMessage(
                    'Erro inesperado. Verifique sua conexão com a internet e tente novamente.',
                )
            } finally {
                if (originalCompanyType) {
                    setLoading(false)
                }
            }
        }
    }

    return (
        <>
            {errorMessage.length > 0 ? (
                <Text style={styles.errorMessage}>{errorMessage}</Text>
            ) : null}
            <Input
                returnKeyType="next"
                autoCapitalize="words"
                style={{ marginBottom: 12 }}
                label="Nome"
                value={name}
                onChangeText={setName}
            />

            <Button
                primary
                style={{ marginTop: 12, marginBottom: 10 }}
                label="Salvar"
                onPress={_save}
            />
            <Button
                secondary
                style={{ marginBottom: 50 }}
                label="Cancelar"
                onPress={onBack}
            />
            <Spinner visible={loading} />
        </>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    errorMessage: {
        color: 'red',
        fontSize: 14,
        marginBottom: 10,
    },
})

export default CompanyTypeForm
